(function(){
  var targets = document.querySelectorAll('.mem-review-count');
  if (!targets.length) return;

  var attempts = 0;
  function fillReviewCount(){
    attempts++;
    var el = document.querySelector('.wwk-sidebar__rating-count');
    var match = el && el.textContent.match(/\d+/);
    if (match) {
      var n = match[0];
      targets.forEach(function(t){
        t.textContent = 'Gebaseerd op ' + n + ' beoordelingen';
        t.hidden = false;
      });
      return;
    }
    if (attempts < 20) setTimeout(fillReviewCount, 500);
  }
  fillReviewCount();
})();
